// Single-shape JSON fetch wrapper for the Prospector dashboard API. Throws on
// transport error, non-2xx, or `success: false` so call sites can use a single
// try/catch with a meaningful `e.message` for the user-facing alert.

export async function fetchJSON(url, { method = "GET", body, errorFallback = "Request failed" } = {}) {
  const init = { method };
  if (body !== undefined) {
    if (typeof FormData !== "undefined" && body instanceof FormData) {
      init.body = body;
    } else {
      init.headers = { "Content-Type": "application/json" };
      init.body = JSON.stringify(body);
    }
  }
  const res = await fetch(url, init);
  const json = await res.json().catch(() => ({}));
  if (!res.ok || !json.success) {
    const err = new Error(json.error || errorFallback);
    err.status = res.status;
    err.body = json;
    throw err;
  }
  return json;
}

export function isInsufficientCreditsError(err) {
  const code = err?.body?.error_code;
  const message = err?.message || err?.body?.error || "";
  return code === "INSUFFICIENT_CREDITS" || /insufficient credits/i.test(message);
}

export function insufficientCreditsMessage(err) {
  return err?.message || err?.body?.error || "You are out of credits. Buy credits to continue.";
}

export function insufficientCreditsDetails(err) {
  const body = err?.body || err || {};
  return {
    message: insufficientCreditsMessage(err),
    actionLabel: body.action_label || null,
    requiredCredits: body.required_credits,
    currentCredits: body.current_credits,
  };
}
